/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : ProductList.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G (E860178)
*
* @Date         : Aug 02, 2019
*
* @Version      : Version 1.0
* By            : Avanthi G (E860178)
* On            : Aug 02, 2019
* Description   : ProductList component added - ASDS-677.
* By            : Avanthi G (E860178)
* On            : Sep 06, 2019
* Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
 *
 * By            : Madhu Gali
 * On            : Sep 13, 2019
 * Description   : ASDS-1178
 *
 * By            : Deepthi Bachu
 * On            : Sep 13, 2019
 * Description   : ASDS-1178
 *
 * By            : Deepthi B (E844276)
 * On            : Sep 23, 2019
 * Description   : Added the code to delete aspire product - ASDS-413
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 *
 * By            : SandeepRaja (E807238)
 * On            : Sep 26, 2019
 * Description   : Show price amount with two floating numbers
 *
 * By            : Madhu Gali (H175591)
 * On            : Oct 03, 2019
 * Description   : ASDS-1476
 *
 * By            : E844276
 * On            : Oct 22, 2019
 * Description   : ASDS-115 changes.
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 05, 2019
 * Description   : ASDS-2018
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            	: Snigdha
 * On            	: Feb 6, 2019
 * Description      : ASDS-2086
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Sep 05 2022
 * Description   : ASDS-8220 - changed key name to id
 *
******************************************************************************/
import * as React from 'react';
import { Grid } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './../ReviewOrder/reviewOrder.css';
import '@scuf/styles/variables.scss';
import { connect } from 'react-redux';
import CartActions from '../redux/actions/cart-details-actions';
import DeleteProduct from './DeleteProduct';
import ConfigureProduct from '../ConfigureProduct/ConfigureProduct';
import CartListComponent from './CartListComponent';
import { logError } from '../../../utils/console-utility';
import ConfigureAPU from '../ConfigureAPU/ConfigureAPU';
import ConfigureWirelessProduct from '../Products/Wireless/ConfigureWirelessProduct';
import ConfigureAPUActions from "../redux/actions/configure-apu-actions";
import ProductAlertActions from 'modules/checkout/redux/actions/products-alerts-action';

interface ProductListPropsI {
    page: string;
    deleteProduct: Function;
    userValidationData: any;
    openEditModel: boolean; // variable to trigger cart item edit
    editProductDetails: any; // details of product editted
    openAPUConfigModel: boolean;
    editAPUProductDetails: any;
    openWirelessConfigModel: boolean;
    editWirelessProductDetails: any;
    cartList: any;
    checkExpiredContracts: Function;
    hideAlert: Function;
    //deleteProducts: Function,
}

interface IProductListState {
    showDeletePopUp: boolean;
    product: {};
    // showWirelessDeleteConfiPopUp: boolean;
    // productsArr: any,
}

class ProductList extends React.PureComponent<ProductListPropsI, IProductListState> {

    constructor(props: ProductListPropsI) {
        super(props);
        this.state = {
            showDeletePopUp: false,
            product: {},
            // showWirelessDeleteConfiPopUp: false,
            // productsArr: [],
        };
        this.handleDeletePopUp = this.handleDeletePopUp.bind(this);
        this.handleDeleteProduct = this.handleDeleteProduct.bind(this);
        this.hideDeletePopUp = this.hideDeletePopUp.bind(this);
        //this.handleWirelessDeleteProducts = this.handleWirelessDeleteProducts.bind(this);
       // this.toggleShowWirelessDeleteConfiPopUp = this.toggleShowWirelessDeleteConfiPopUp.bind(this);
    }

    // toggleShowWirelessDeleteConfiPopUp = () => {
    //     this.setState({ showWirelessDeleteConfiPopUp: !this.state.showWirelessDeleteConfiPopUp });
    // }

    async componentDidMount() {
        this.props.hideAlert();
        const userId = this.props.userValidationData.payload.userInfo.customer_sub;
        if (!userId) {
            logError('Invalid UserId');
        }
        else {
            this.props.checkExpiredContracts(userId);
        }
    }

    handleDeletePopUp = (product) => {
        // const systemName = product.system;
        // const productId = product.productId;
        // //added the delete pop-up conditions for ASDS-2086
        // if (systemName === CheckoutConstants.BMS_SYS_NAME && (productId === CheckoutConstants.DLMUW_PRODUCT_ID || productId === CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_ID)) {
        //     const myCartList: any = this.props.cartList;
        //     let productsArr : [];
        //     if(productId === CheckoutConstants.DLMUW_PRODUCT_ID){
        //     productsArr = myCartList
        //         .filter(ele => ele.system === CheckoutConstants.BMS_SYS_NAME)
        //         .filter(ele => (ele.productId === CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_ID
        //             || ele.productId === CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_ID))
        //         ;
        //     }else{
        //     productsArr = myCartList
        //         .filter(ele => ele.system === CheckoutConstants.BMS_SYS_NAME)
        //         .filter(ele =>  (ele.productId === CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_ID))
        //         ;
        //     }
        //     if (productsArr.length) {
        //         this.showWirelessDeleteConfiPopUp(productsArr, product);
        //     } else {
        //         this.showDeletePopUp(product);
        //     }
        // } else {
        //     this.showDeletePopUp(product);
        // }
        this.showDeletePopUp(product);
    }

    // showWirelessDeleteConfiPopUp = (productsArr, product) => {
    //     this.setState({
    //         showWirelessDeleteConfiPopUp: !this.state.showWirelessDeleteConfiPopUp,
    //         productsArr,
    //         product,
    //     });
    // }

    // handleWirelessDeleteProducts = async () => {
    //     const productsArr: [] = this.state.productsArr;
    //     const tempProductsArr = [...productsArr, this.state.product];
    //     await this.props.deleteProducts(tempProductsArr);
    //     this.setState({
    //         showWirelessDeleteConfiPopUp: !this.state.showWirelessDeleteConfiPopUp,
    //     })
    // }

    showDeletePopUp = (product) => {
        this.setState({
            showDeletePopUp: !this.state.showDeletePopUp,
            product: product,
        });
    }

    handleDeleteProduct = async () => {
        await this.props.deleteProduct(this.state.product);
        this.setState({
            showDeletePopUp: !this.state.showDeletePopUp,
            product: {},
        });
        window.scrollTo(0, 0);
    }

    hideDeletePopUp = () => {
        this.setState({
            showDeletePopUp: !this.state.showDeletePopUp,
            product: {},
        });
    }

    render() {
        return (
            <Grid.Row className="fullwidthRow">
                <Grid.Column width={12} className="fullwidthRow cartListCard">
                    <CartListComponent {...this.props} onClick={this.handleDeletePopUp} />
                    {this.state.showDeletePopUp
                        && <DeleteProduct
                            product={this.state.product}
                            onClose={this.hideDeletePopUp}
                            open={this.state.showDeletePopUp}
                            onClick={this.handleDeleteProduct} />
                    }
                    {/* {this.state.showWirelessDeleteConfiPopUp
                        && <WirelessDeleteProductConfirmation
                            open={this.state.showWirelessDeleteConfiPopUp}
                            productsArr={this.state.productsArr}
                            product={this.state.product}
                            onClick={this.handleWirelessDeleteProducts}
                            onClose={this.toggleShowWirelessDeleteConfiPopUp}
                        />
                    } */}
                    {this.props.openEditModel && <ConfigureProduct open={this.props.openEditModel} productId={this.props.editProductDetails.productId} productName={this.props.editProductDetails.productName} />}
                    {this.props.openAPUConfigModel && <ConfigureAPU open={this.props.openAPUConfigModel} productId={this.props.editAPUProductDetails.productId} productName={this.props.editAPUProductDetails.productName} />}
                    {this.props.openWirelessConfigModel && <ConfigureWirelessProduct open={this.props.openWirelessConfigModel} wirelessProductId={this.props.editWirelessProductDetails.productId}
                        wirelessProductName={this.props.editWirelessProductDetails.productName}
                        wirelessProductPrice={this.props.editWirelessProductDetails.price} />}
                </Grid.Column>
            </Grid.Row>);
    }
}

function mapStateToProps(store) {
    const { isFetching, totalAmount, cartList, isSuccess } = store.cartDetails.selectedCartList;
    return {
        isFetching, totalAmount, cartList, isSuccess,
        userValidationData: store.userValidationData,
        openEditModel: store.cartDetails.openEditModel,
        openAPUConfigModel: store.cartDetails.openAPUConfigModel,
        editProductDetails: store.cartDetails.editProductDetails,
        editAPUProductDetails: store.cartDetails.editAPUProductDetails,
        openWirelessConfigModel: store.cartDetails.openWirelessConfigModel,
        editWirelessProductDetails: store.cartDetails.editWirelessProductDetails,
    };
}

const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
    deleteProduct: CartActions.deleteProduct,
    showEditModel: CartActions.showEditModel,
    showEditModelAPU: CartActions.showEditModelAPU,
    showEditModelWireless: CartActions.showEditModelWireless,
    checkExpiredContracts: ConfigureAPUActions.checkExpiredContracts,
    //deleteProducts: CartActions.deleteProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);